export const member = {
  placeholder: {
    id: { en: 'ID', ko: '아이디' },
    email: { en: 'email', ko: '이메일' },
    certificateNum: { en: 'certificate number', ko: '인증번호' },
    pw: { en: 'password', ko: '비밀번호' },
    newPW: { en: 'new password', ko: '새 비밀번호' },
    newPWConfirm: { en: 'confirm new password', ko: '새 비밀번호 확인' },
  },
  title: {
    findId: { en: 'Find ID', ko: '아이디 찾기' },
    successFindId: { en: 'Find ID result', ko: '아이디 찾기 결과' },
    resetPW: { en: 'Reset password', ko: '비밀번호 재설정' },
    newPW: { en: 'Change password', ko: '비밀번호 재설정' },
  },
  button: {
    send: { en: 'Send', ko: '인증번호 발송' },
    resend: { en: 'Resend', ko: '인증번호 재발송' },
    toLogin: { en: 'Login page', ko: '로그인 페이지로' },
    resetPassword: { en: 'Reset password', ko: '비밀번호 재설정' },
    login: { en: 'Login', ko: '로그인' },
    change: { en: 'Change', ko: '변경' },
    loading: { en: 'Sending', ko: '발송중' },
  },
  word: {
    idIs: { en: 'Your ID is', ko: '아이디는' },
    is: { en: '', ko: '입니다.' },
  },
};
